/* Code generated with AutoHTML Plugin for Figma */
import React from "react";
import { _colorText, _sizeHeading } from "../../core/core";
import "./title.css";

interface TitleProps {
  type?: string;
  color?: string;
  is_first_type?: boolean;
  children: React.ReactNode;
  [key: string]: any;
}

const Title: React.FC<TitleProps> = ({
  type = _sizeHeading.h2,
  color = _colorText.default,
  is_first_type = false,
  children,
  ...props
}) => {
  const variantsClass = () => `${type} heading-${color}`;

  const renderTitle = () => {
    if (is_first_type || type === _sizeHeading.h1) {
      return (
        <h1 className={variantsClass()} {...props}>
          {children}
        </h1>
      );
    }
    if (type === _sizeHeading.h2) {
      return (
        <h2 className={variantsClass()} {...props}>
          {children}
        </h2>
      );
    }
    if (type === _sizeHeading.h3) {
      return (
        <h3 className={variantsClass()} {...props}>
          {children}
        </h3>
      );
    }
    return (
      <h2 className={variantsClass()} {...props}>
        {children}
      </h2>
    );
  };

  return renderTitle();
};

export default Title;
